
import Vue from 'vue';
import Component from 'vue-class-component';

// Api
import { getOfferURL } from '@/utils/Api';

// Components
import { VAppLayout, VAppMain } from '@/components/VApp';
import { VGridPageColumn, VGridRow, VGridCol } from 'vui';
import VSpinner from '@/components/VSpinner.vue';

@Component({
    components: {
        VGridRow,
        VGridCol,
        VSpinner,
        VGridPageColumn,
        VAppLayout,
        VAppMain,
    },
})
export default class OfferPage extends Vue {
    public offerURL: string = '';
    public errorMessage: string = '';
    public isLoading: boolean = true;

    public async fetchOfferURL() {
        this.isLoading = true;

        try {
            const response = await getOfferURL();

            this.offerURL = this.parseURL(response.data);
        } catch (error) {
            this.errorMessage = (error as Error).message;
        } finally {
            this.isLoading = false;
        }
    }

    public async created() {
        await this.fetchOfferURL();
    }

    private parseURL(url: string): string {
        const index = url.indexOf('/download');

        // If the url contains download segment, we remove it.
        if (index !== -1) {
            url = url.substring(index, -1);
        }

        // If the url does not contain preview param, we add it.
        if (url.indexOf('preview=true') === -1) {
            const tempURL = new URL(url);

            tempURL.searchParams.append('preview', 'true');

            url = tempURL.href;
        }

        return url;
    }
}
